<script>
import ReservoirWaterRegime from "@/views/count/water/ReservoirWaterRegime.vue";
import RiverWaterRegime from "@/views/count/water/RiverWaterRegime.vue";
export default {
  name: "water",
  components: {ReservoirWaterRegime, RiverWaterRegime},
  data() {
    return {
      period: 'sksq'
    }
  },
}
</script>

<template>
  <el-container style="padding: 20px;">
    <el-tabs v-model="period" @tab-click="" style="width: 100%;">
      <el-tab-pane label="水库水情报表" name="sksq">
        <reservoir-water-regime></reservoir-water-regime>
      </el-tab-pane>
      <el-tab-pane label="河道水情报表" name="hdsq">
        <river-water-regime></river-water-regime>
      </el-tab-pane>
    </el-tabs>
  </el-container>
</template>

<style scoped>
/* 按钮样式 */
::v-deep .queryButton {
  font-family: PingFang SC;
  font-size: 1.4rem;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0rem;
  border-radius: 0.5rem;
  margin-left: 1.5rem;
}

::v-deep .queryButtonPadding {
  padding-left: 2rem;
  padding-right: 2rem;
}

::v-deep .qDcBtn {
  position: absolute;
  right: 4rem;
}

::v-deep .qDcImg {
  width: 1.2rem;
  height: 1.2rem;
}
</style>